import angular from 'angular';
import referralAlert from './referralAlert';

export default angular
  .module('components.referralAlert', [])
  .component('referralAlert', referralAlert).name;
